import { UID } from 'shared/api/query/constants';
import { resourceSettings as resourceSettingsConfig } from 'shared/api/query/configs.json';

export const children = [
  { attr: UID },
  { attr: resourceSettingsConfig.edges.spaceOrder, default: [] },
  { attr: resourceSettingsConfig.edges.privateDashboardsCount, default: 0 },
  { attr: resourceSettingsConfig.edges.publicDashboardsCount, default: 0 },
];
